import { PageDTO } from './CommonDTOs';
import { UserInfoDTO } from './UserDTOs';
import { BannerType } from '../common/enums';



export class BannerInfoDTO {
  user: UserInfoDTO = new UserInfoDTO();
	
  id: number = 0;
  bannerType: BannerType | null = null;
  title: string = '';
  bannerDesc: string = '';
  link: string = '';
  active: boolean = false;
  imgFileId: string | null = null;
  imgUrl: string | null = null;
}


export class BannerInputReqDTO {

  imgTmpFileId: string|null = null;
  bannerType: BannerType | null = null;
  title: string = '';
  bannerDesc: string = '';
  link: string = '';
  active: boolean = true;
}
